import { render, staticRenderFns } from "./basic-info.page.vue?vue&type=template&id=30fc6d94&scoped=true&"
import script from "./basic-info.page.vue?vue&type=script&lang=js&"
export * from "./basic-info.page.vue?vue&type=script&lang=js&"
import style0 from "./basic-info.page.vue?vue&type=style&index=0&id=30fc6d94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fc6d94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VForm,VIcon})
